import React, { useRef } from "react";
import Typography from "@mui/material/Typography";
import "react-medium-image-zoom/dist/styles.css";
import Divider from "@mui/material/Divider";
import "../JaldiLab.css";
import {
  referenceHtml,
  referenceTootKit,
  sectionStyle,
  h1style,
  h2style,
  h3style,
  subHeadingStyle,
  getTextContentHeading,
  DividerBorderStyle,
  paraStyle,
  tableCaption,
  getCircleTypeListItem,
  customHeading4,
  generateUnOrderedList,
  subHeadingContent,
  generateTableUnOrderedList,
} from "./ChapterList";
import design from "../../../assets/SvgIcons/design-consideration.svg";
import adjacencies from "../../../assets/SvgIcons/adjacencies.svg";
import designConsideration from "../../../assets/SvgIcons/design-consideration.svg";
import user from "../../../assets/SvgIcons/users.svg";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import objective from "../../../assets/SvgIcons/obj.svg";
import officeSpace1 from "../../../assets/Images/Office Space Images/officeSpace1.png";
import officeSpace2 from "../../../assets/Images/Office Space Images/officeSpace2.png";
import officeSpace3 from "../../../assets/Images/Office Space Images/officeSpace3.png";
import officeSpace4 from "../../../assets/Images/Office Space Images/officeSpace4.jpg";
import officeSpace5 from "../../../assets/Images/Office Space Images/officeSpace5.jpg";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { FigureDesc51, FigureDesc52 } from "../../../utils/tmp/ImageDescription/OfficeSpacesID";

const borderColor = "#AAAAAA";
const specialBorderColor = "#F3F3F4";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F45B69",
    color: theme.palette.common.white,
    fontWeight: 700,
    border: `1px solid ${borderColor}`,
    verticalAlign: "baseline",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#555555",
    border: `1px solid ${borderColor}`,
    verticalAlign: "baseline",
  },
  "&.bold-text": {
    fontWeight: 700,
  },
  "&:first-child": {
    borderLeft: `1px solid ${specialBorderColor}`,
  },
  "&:last-child": {
    borderRight: `1px solid ${specialBorderColor}`,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#CCE5E5",
  },
}));

const referenceStyle = {
  color: "black",
  fontFamily: "GT Super Text",
  fontSize: " 24px",
  fontWeight: "700",
  letterSpacing: "0px",
  textAlign: "left",
  fontStyle: "italic",
  cursor: "pointer",
  marginBottom: "10px",
};

const OfficeSpacesPage = ({ goToSection }) => {
  const referencesRef = useRef(null);
  const reference = (_data, number) => {
    return referenceTootKit(_data, number, handleScrollToReferences);
  };
  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };

  // const pointStyle = {
  const registererData = {
    icon: <img src={design} />,
    heading: "Design Considerations",
    data: [
      "The room must be provided with ergonomic furniture including a desk, a seating area, along with space to keep personal belongings, and adequate storage facilities for at least one day’s worth of case files. ",
      "Additional facilities to accommodate the various roles and responsibilities of the Registrar must be provided, as required.",
      "The room should be in close proximity to or must have additional space for a Personal secretary, as required.",
      <>
        In such instances, where other staff members are associated with the
        office of the Registrar, they must have an office in close proximity to
        the Registrar’s Chamber. For further details for the layout of a
        Multi-Person Workspace, please refer to{" "}
        <span style={sectionStyle}>Figure 52</span>.
      </>,
    ],
    isOrdered: false,
    isImage: true,
  };

  const referenceData = [
    {
      content:
        "The term Shirestedar is used in Courts under the jurisdiction of the Hon’ble Karnataka High Court and the Ahlmad in the Courts under the jurisdiction of the Hon’ble Delhi High Court. The term varies further from jurisdiction to jurisdiction. However, for the purpose of this Handbook, the term “Shirestedar” or “Clerk” has been used.",
    },
    {
      content: "Model Live Streaming Rules, section 3",
    },
  ];

  const designItem = [
    "Shelving: fixed lateral shelving, hanging open-box files, movable lateral shelving, vertical drawer filing, and mechanised filing;",
    "Specialised filing equipment and supplies: card-filing equipment, top or open reference files, file folders and supports; and",
    "Computer-product-filing equipment: for printouts, tapes, disks, platter, and microfilm-filing equipment.",
  ];

  return (
    <div>
      <Typography>
        <h1 id="handbookPrinciple" style={h1style}>
          PART C - THE HANDBOOK
        </h1>
        <h2 style={h2style}>
          <span style={{ fontSize: "24px" }}>2. </span>
          ORGANIZATION AND DESIGN OF SPACES OF THE COURT COMPLEX
        </h2>
        <h3 style={h3style}>
          <span style={{ fontSize: "20px" }}>2.5. </span>
          Administrative Wing
        </h3>
        <h4 id="officeSpacesSingleWorkspace" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.5.</span>B. Office Spaces (Single
          Workspace)
        </h4>
        <h3 id="registrarAdministrativeOfficeChamber" style={subHeadingStyle}>
          I. Registrar’s/Administrative Officer’s Chamber
        </h3>

        <p style={paraStyle}>
          The Registrar's/Administrative Officer’s Chamber serves as the office
          of the Court registrar or of an equivalent Administrative Officer, who
          is responsible for managing Court records, supervising administrative
          staff, and undertaking other administrative functions. The Chamber
          must be located in close proximity to staircases, lifts, and ramps, as
          well as the office of Assistant Registrar (where applicable).
        </p>

        {getTextContentHeading(registererData)}
        <DividerBorderStyle />
        <h4 id="shirestedarCourtClerkRoom" style={subHeadingStyle}>
          II. Court Clerk/Shirestedar Room
        </h4>

        <p style={paraStyle}>
          The Court Clerk Room refers to the space to be provided for the
          shirestedars/ahlmads, i.e., the officers attached to each Courtroom.
          {reference(referenceData[0], 1)} These clerks are responsible for
          monitoring all pending case files of a particular day which are to be
          moved between the Courtroom and the pending branch, as well as other
          administrative functions with regard to case management, as may be
          deemed necessary by the Judge.
        </p>
        <p style={paraStyle}>
          The space provided must ensure that the clerks have adequate space for
          their personal belongings, seating arrangements, and storage space for
          case files. The room must have direct access to the Courtroom, pending
          branch, and the common public corridor.
        </p>
        <CaptionWithBorders1
          image={[officeSpace1]}
          isZoom={true}
          caption={"Figure 51: Typical floor plan for a 1-Person Office Space"}
          zoomImgStyle={{ height: "400px" }}
          imageDescription={FigureDesc51}
        />

        <DividerBorderStyle />
        <h4 id="officeSpacesMultiPersonWorkspace" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.5.</span>C. Office Spaces
          (Multi-Person Workspace)
        </h4>
        <h4 id="officeforRegistrarStaff" style={subHeadingStyle}>
          I. Office for Registrar’s Staff
        </h4>
        <p style={paraStyle}>
          These offices cater to the administrative needs of the Registrar and
          Assistant Registrar (where applicable). The staff are responsible for
          smooth coordination with other administrative offices.
        </p>

        <DividerBorderStyle />

        <h4 id="summonsOfficeandProcess" style={subHeadingStyle}>
          II. Summons Office and Process Server Room{" "}
        </h4>
        <p style={paraStyle}>
          The summons office (also called the nazar branch in some Courts)
          refers to the space required for undertaking functions relating to the
          service of summons, including generating, signing and storing, and
          allocation to various process servers who ultimately deliver the
          summons to parties as required.
        </p>
        <p style={paraStyle}>
          The nazar branch must have provisions for both physical summons and
          online modes of service, including N-STEP as well as other digital
          means. Adequate IT infrastructure must be provided.
        </p>
        <p style={paraStyle}>
          An additional room must be provided within this space for process
          servers to rest while they are not being required to deliver summons.
          This area may also be equipped with a small pantry and must have
          storage space for their personal belongings.
        </p>
        <DividerBorderStyle />

        <h4 id="accountsSection" style={subHeadingStyle}>
          III. Accounts Section
        </h4>
        <p style={paraStyle}>
          The accounts department handles financial matters and budgeting for
          the Court. The area must be organised to accommodate all staff, and
          may be located in proximity to the Registrar’s chamber.
        </p>
        <p style={paraStyle}>
          The confidentiality of financial records and transactions must be
          maintained. For further details, refer to{" "}
          <span
            onClick={() =>
              goToSection("managementPoliciesStrategies", "dataManagement")
            }
            style={sectionStyle}
          >
            {" "}
            PART D, Section 4.2
          </span>
          .
        </p>
        <DividerBorderStyle />

        <h4 id="computerSection" style={subHeadingStyle}>
          IV. Computer Section
        </h4>
        <p style={paraStyle}>
          The computer section refers to the space allocated for the Computer
          Committee and other technical staff employed by the Court, including
          the Central Project Coordinator appointed under the e-Courts project.
          The room may be in proximity to the filing section and
          copying/dispatch section for effective coordination.
        </p>
        <p style={paraStyle}>
          Accessible information and data systems, as well as telecommunication
          requirements, must be provided. Additionally, the computer section
          must have adequate, ergonomic, and accessible desks and workstations
          for all staff, and adequate storage space for their personal
          belongings.
        </p>
        <DividerBorderStyle />

        <h4 id="digitisationRoom" style={subHeadingStyle}>
          V. Digitisation Room
        </h4>
        <p style={paraStyle}>
          The digitisation room is dedicated to converting physical Court
          documents into digital formats. This includes the digitisation of
          incoming files, pending files on a priority basis in accordance with
          the rules developed by each Court, and of disposed cases. The
          digitisation room may be in proximity to the filing section, the
          pending branch, and the record room for effective coordination.
        </p>
        <p style={paraStyle}>
          Adequate, accessible IT support infrastructure, including high-quality
          scanning systems, must be provided. Additionally, the digitisation
          room must have adequate working space for all staff, and adequate
          storage space for their personal belongings.
        </p>
        <DividerBorderStyle />

        <h4 id="commandControlCentre" style={subHeadingStyle}>
          VI. Command & Control Centre
        </h4>
        <p style={paraStyle}>
          This area serves as the control centre in instances of emergency and
          evacuations. It aggregates all the ICT subsystems of the Court Complex
          including all the security operations being undertaken. The space must
          be continuously manned with adequate security provisions. For further
          details, refer to{" "}
          <span
            onClick={() => goToSection("annexes", "HeadingAnnexure3")}
            style={sectionStyle}
          >
            {" "}
            Annexure 3
          </span>
          . Provisions must be made for adequate comfortable seating for all
          users.
        </p>
        <p style={paraStyle}>
          A secure, temperature controlled Server/Telecommunication Room must
          also be provided in direct connection or close proximity to the
          Command & Control Centre, to accommodate all IT Services including,
          inter alia, Networking, Data, IP Camera system including Video
          recording, Building Management Systems, etc.
        </p>
        <DividerBorderStyle />

        <h4 id="dedicatedControlRoom" style={subHeadingStyle}>
          VII. Dedicated Control Room
        </h4>
        <p style={paraStyle}>
          The Model Rules for Live Streaming and Recording of Court Proceedings,
          adopted by the eCommittee of the Supreme Court on 13 September 2022,
          mandate a Dedicated Control Room (DCR) to be set up in each Court.
          {reference(referenceData[1], 2)} The DCR is responsible for monitoring
          and tracking proceedings as they are live streamed, recorded, and
          transcribed, in accordance with the rules adopted by the Court. The
          DCR must be manned by Court officers, technical and video-recording
          experts, under the direct supervision of the Registrar (IT) or their
          nominees.
        </p>
        <p style={paraStyle}>
          Additionally, the Model Rules for Video Conferencing for Courts
          requires certain technical support persons to be tasked with ensuring
          seamless video conferencing. The technical team associated with the
          DCR may also be tasked with facilitating the same.
        </p>

        {/* table  */}
        <div style={{ margin: "30px 0" }}>
          <p className="table-guidance-heading">
            <span className="table-guidline-text">Table 9: </span>
            <br />
            <span style={tableCaption}>
              Functions to be coordinated from the Dedicated Control Room
            </span>
          </p>
          <TableContainer>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Section No.</StyledTableCell>
                  <StyledTableCell>Section Title</StyledTableCell>
                  <StyledTableCell>Section Relevant Details</StyledTableCell>
                  <StyledTableCell>Design Considerations</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell colSpan={4} sx={{ textAlign: "center" }}>
                    Model Live Streaming Rules
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell>S. 3.</StyledTableCell>
                  <StyledTableCell>
                    Requisitioning and Positioning of Human Resources
                  </StyledTableCell>
                  <StyledTableCell>
                    <span style={sectionStyle}>3.2.</span> The DCR shall, inter
                    alia, comprise an officer of the Court, technical and video-
                    recording experts. The DCR will monitor and track
                    proceedings as they are live streamed, recorded, and
                    transcribed. The DCR shall ensure that nothing uncivil or
                    inappropriate is streamed in the public domain.
                  </StyledTableCell>
                  <StyledTableCell>
                    {generateTableUnOrderedList([
                      "Adequate technology must be provided to facilitate and monitor the recording and broadcast (where necessary) of the                 proceedings. Adequate space must be provided for the personnel hired to monitor the same.",
                    ])}
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell>S. 10.</StyledTableCell>
                  <StyledTableCell>Transcription and Access</StyledTableCell>
                  <StyledTableCell>
                    <span style={sectionStyle}>10.1.</span> Transcripts shall be
                    prepared of recordings only when directed by the Court.
                    10.2. The transcripts may be translated into other scheduled
                    languages. 10.3. Recordings that are uploaded will be made
                    accessible for differently abled persons
                  </StyledTableCell>
                  <StyledTableCell>
                    {generateTableUnOrderedList([
                      "Adequate tools must be incorporated for live transcription of the recordings.",
                    ])}
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell colSpan={4} sx={{ textAlign: "center" }}>
                    Model Video Conferencing Rules
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell>S.8.</StyledTableCell>
                  <StyledTableCell>Examination of persons</StyledTableCell>
                  <StyledTableCell>
                    <span style={sectionStyle}>8.15.</span> Where a Required
                    Person is not capable of reaching the Court Point or the
                    Remote Point due to sickness or physical infirmity, or
                    presence of the required person cannot be secured without
                    undue delay or expense, the Court may authorize the conduct
                    of video conferencing from the place at which such person is
                    located. In such circumstances the Court may direct the use
                    of portable video conferencing systems
                  </StyledTableCell>
                  <StyledTableCell>
                    {generateTableUnOrderedList([
                      "Portable video conferencing systems may be used in specific circumstances and must be provided for.",
                    ])}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <DividerBorderStyle />
        <h4 id="housekeepingOffice" style={subHeadingStyle}>
          VIII. Housekeeping Office/Office for Other Staff
        </h4>
        <p style={paraStyle}>
          This area serves as the office for housekeeping staff and other
          support personnel. Seating area must be provided, and the room may be
          equipped with a small pantry. Adequate storage space must be provided
          for housekeeping supplies and equipment, as well as the personal
          belongings of the staff.
        </p>
        <CaptionWithBorders1
          image={[officeSpace2]}
          isZoom={true}
          caption={"Figure 52: Typical floor plan for a 6-Person Office Space"}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={FigureDesc52}
        />

        <h2 ref={referencesRef} id="officeRef" style={referenceStyle}>
          References
          <Divider />
        </h2>
        {referenceHtml(referenceData)}
      </Typography>
    </div>
  );
};

export default OfficeSpacesPage;
